import TimeStamp from "@/services/timeStamp";
import FirebaseWrite from "@/services/database/firebaseWrite";

export default class PRINT_PAESSE_UPDATE_SPIELER{
    static getPromiseList(passList){
        const selectedSpielerList = passList.filter( spieler =>
            PRINT_PAESSE_UPDATE_SPIELER.atLeastOnePassSelected(spieler.passList)
        )
        if ( selectedSpielerList.length === 0 ) return
        return PRINT_PAESSE_UPDATE_SPIELER.createPromiseList(selectedSpielerList)
    }

    static atLeastOnePassSelected(spielerPassList){
        let atLeastOnePassSelected = false
        spielerPassList.forEach( (passItem) => {
            if ( passItem.selected ) atLeastOnePassSelected = true
        });
        return atLeastOnePassSelected
    }

    static createPromiseList(selectedSpielerList){
        const promiseList = []
        selectedSpielerList.forEach( (selectedSpieler) => {
            const updateObject = PRINT_PAESSE_UPDATE_SPIELER.getSpielerUpdateOpject(selectedSpieler)
            const p = FirebaseWrite.update('spieler', selectedSpieler.spielerObjekt.id, updateObject)
            promiseList.push(p)
        });
        return promiseList
    }

    static getSpielerUpdateOpject(selectedSpieler) {
        const ts = TimeStamp.getGMTTimestamp()
        let updateObject = {
            tsLastPassPrint: ts,
            waitingForPassPrint: false,
            waitingForPlayerPassPrint: false,
        }
        selectedSpieler.passList.forEach( (passItem) => {
            if ( !passItem.selected ) {
                updateObject.waitingForPassPrint = true
                if ( passItem.type === 'sp') updateObject.waitingForPlayerPassPrint = true
            } else {
                if ( passItem.type === 'sp' ) {
                    updateObject.tsLastPlayerPassPrint = ts
                } else {
                    updateObject['roles.'+passItem.type+'.waitingForPassPrint'] = false
                    updateObject['roles.'+passItem.type+'.tsLastPassPrint'] = ts
                }
            }
        });
        return updateObject
    }

    static getUpdateObjectForFotoChange(selectedSpieler, url){
        const updateObject = {
            url: url,
            waitingForPassPrint: true,
            waitingForPlayerPassPrint: true,
        }
        if ( selectedSpieler.roles ) {
            Object.keys(selectedSpieler.roles).forEach( (roleId) => {
                if ( roleId !== 'isSchiedsrichter' && roleId !== 'isTrainer' ) {
                    updateObject['roles.'+roleId+'.waitingForPassPrint'] = true
                }
            });
        }
        return updateObject
    }
}